import { Card, CardContent, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const formatCurrency = (value, currency) =>
  `${currency}${Number((value / 100) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

function getColor(status) {
  let color = "#111827";

  if (status === "SUCCESS") {
    color = "#2E7D32"; // MUI success.main
  }

  if (status === "AWAITING-PAYMENT") {
    color = "#0288D1"; // MUI info.main
  }

  if (status === "AWAITING-CONFIRMATION") {
    color = "#ED6C02"; // MUI warning.main
  }

  return color;
}

export default function DonutChart({ title, data, dataKey, currency }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={320}>
          <PieChart>
            <Pie
              data={data}
              dataKey={dataKey}
              nameKey="name"
              innerRadius={70}
              outerRadius={100}
            >
              {data.map((row, index) => (
                <Cell
                  key={index}
                  fill={getColor(row.name)}
                />
              ))}
            </Pie>

            <Tooltip
              formatter={(value) => formatCurrency(value, currency)}
            />

            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}